/* Color swatches */

const colorSwatchesAll = document.querySelectorAll('.product-card-swatches .color-swatches__list');
console.log(colorSwatchesAll);
for (let i = 0; i < colorSwatchesAll.length; i++) {
    const colorSwatchesAllchildren = colorSwatchesAll[i].children;

    for (let j = 0; j < colorSwatchesAllchildren.length; j++) {
        colorSwatchesAllchildren[j].addEventListener('mouseover', function (e) {
            const target = e.target.closest('.color-swatches__list li');
            const productHandle = target.dataset.productHandle;
            const productWrapper = target.closest('.card-wrapper');
            const img = target.dataset.productImage;
            const imgSrcset = target.dataset.productImageSrcset;
            const img2 = target.dataset.productImage2;
            const imgSrcset2 = target.dataset.productImageSrcset2;
            const link = productWrapper.querySelector('.card__title a');
            link.textContent = target.dataset.productTitle;
            link.setAttribute("href", target.dataset.productUrl);

            const absLink = productWrapper.querySelector('.link');
            absLink.setAttribute("href", target.dataset.productUrl);

            const image = productWrapper.querySelector('.media img');
            image.setAttribute("srcset", img);
            image.setAttribute("src", imgSrcset);

            if (productWrapper.querySelectorAll('.media img').length>1) {
                const image2 = productWrapper.querySelectorAll('.media img')[1];
                image2.setAttribute("srcset", img2);
                image2.setAttribute("src", imgSrcset2);
            }

            for (let k = 0; k < colorSwatchesAllchildren.length; k++) {
                colorSwatchesAllchildren[k].classList.remove('color-swatches__list__current');
            }
            target.classList.add('color-swatches__list__current');

            // Update product sizes
            const sizes = productWrapper.querySelector('.sizes-swatches__list');

            for (let l = 0; l < sizes.children.length; l++) {
                sizes.children[l].style.display = 'none';
            };
            sizes.querySelector(`[data-product-handle="${productHandle}"]`).style.display = 'inline-block';
        });
    }
}
